import "./css/normalize.css"; //CSS reset
import "./css/site.css";

import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { ARTISTS, ROUTES } from "../data/content";
import ScrollToTop from "./general/ScrollToTop";
import { EnquiryProvider } from "./general/Enquiry";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Home from "./home/Home";
import About from "./about/About";
import ArtistPage from "./artists/ArtistPage";
import Ardmore from "./ardmore/Ardmore";
import BirdLife from "./birdlife/BirdLife";
import Shop from "./shop/Shop";
import Artwork from "./shop/Artwork";
import NotFound from "./general/NotFound";

const App = () => {
  return (
    <EnquiryProvider>
      <a
        className={"skip-link"}
        href={"#main"}
      >
        Skip to main content
      </a>
      <ScrollToTop />
      <Header />
      <main
        id={"main"}
        className={"site-main"}
      >
        <Routes>
          <Route
            path={ROUTES.HOME}
            element={<Home />}
          />
          <Route
            path={ROUTES.ABOUT}
            element={<About />}
          />
          {ARTISTS.map((artist) => (
            <Route
              key={artist.slug}
              path={artist.path}
              element={<ArtistPage artist={artist} />}
            />
          ))}
          <Route
            path={ROUTES.ARDMORE}
            element={<Ardmore />}
          />
          <Route
            path={ROUTES.BIRDLIFE}
            element={<BirdLife />}
          />
          <Route
            path={ROUTES.CATEGORY}
            element={<Shop />}
          />
          <Route
            path={ROUTES.ARTWORK}
            element={<Artwork />}
          />
          {/* Wix template pages with placeholder events that were never used - send old links home */}
          {["/exhibitions", "/events-page", "/events/*"].map((path) => (
            <Route
              key={path}
              path={path}
              element={(
                <Navigate
                  to={ROUTES.HOME}
                  replace
                />
              )}
            />
          ))}
          <Route
            path={"*"}
            element={<NotFound />}
          />
        </Routes>
      </main>
      <Footer />
    </EnquiryProvider>
  );
};

export default App;
